import React, { useState, useEffect } from "react";
import BASE_URL from "../../config/config";
import Captcha from "./Captcha"; // کامپوننت کپچای داخلی

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [csrfToken, setCsrfToken] = useState("");
  const [captchaVerified, setCaptchaVerified] = useState(false);

  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await fetch(`${BASE_URL}/csrf-token`, {
          credentials: "include",
        });
        const data = await response.json();

        if (!data.csrfToken) {
          console.error("CSRF token not received or invalid!");
        } else {
          setCsrfToken(data.csrfToken);
        }
      } catch (error) {
        console.error("Error fetching CSRF token:", error);
      }
    };

    fetchCsrfToken();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage("");

    if (!captchaVerified) {
      setMessage("لطفاً کد امنیتی را تأیید کنید.");
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "CSRF-Token": csrfToken,
        },
        body: JSON.stringify({ email }),
        credentials: "include",
      });

      if (response.ok) {
        setMessage("ایمیلی حاوی لینک بازیابی رمز عبور برای شما ارسال شد.");
      } else {
        const data = await response.json();
        setMessage(data.message || "خطایی در ارسال درخواست رخ داد.");
      }
    } catch (error) {
      setMessage("خطایی رخ داد. لطفاً دوباره تلاش کنید.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="form-cont">
      <div className="form-box" id="forgot-password">
        <h2>بازیابی رمز عبور</h2>
        <form onSubmit={handleSubmit}>
          {/* کامپوننت CAPTCHA داخلی */}
          <Captcha 
            onVerify={(isVerified) => setCaptchaVerified(isVerified)}
            onExpire={() => setCaptchaVerified(false)}
            timeout={120000}
            regenerateOnError={true}
          />
          
          <div className="input-group">
            <label htmlFor="email">ایمیل</label>
            <input
              type="email"
              id="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          
          {message && (
            <p className={message.includes("خطا") ? "error-message" : "success-message"}>
              {message}
            </p>
          )}
          
          <button type="submit" disabled={isLoading || !captchaVerified}>
            {isLoading ? "در حال ارسال درخواست..." : "ارسال لینک بازیابی"}
          </button>
        </form>
      </div>
    </div>
  );
}